<template>

  <div :class="['axiome-logique-container', 'axiome-logique-union-of']">
    <span class="brace-container-left" />

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">

      <PropertyValue :values="otherUnionOfLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge"
        axiomLogicOperand="or" />

      <AttributeBlankNode :blankNodes="blankNodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" axiomLogicOperand="or"
        :showFirstOperand="otherUnionOfLiterals !== undefined && otherUnionOfLiterals.length > 0" />
    </div>
  </div>

</template>

<script>

export default {
  name: "LogicalAxiomeUnionOf",

  computed: {
    otherUnionOfLiterals() {
      let literals = [];
      this.otherUnionOf.forEach(element => {
        literals.push(...element.literals);
      });
      return literals;
    },
    blankNodes() {
      let blankNodes = [];
      this.otherUnionOf.forEach(element => {
        blankNodes.push(...element.blankNodes);
      })
      return blankNodes;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    otherUnionOf: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
